import { Settings2, Tablet, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Tabs, type TabConfig } from "@/components/ui";
import type { HouseDetailTabId } from "./useHouseDetailTab";

export type { HouseDetailTabId };

interface HouseDetailTabNavProps {
  activeTab: HouseDetailTabId;
  onTabChange: (tab: HouseDetailTabId) => void;
  showPresencesTab?: boolean;
}

export function HouseDetailTabNav({
  activeTab,
  onTabChange,
  showPresencesTab = false,
}: HouseDetailTabNavProps) {
  const { t } = useTranslation("houses");

  const tabs: TabConfig<HouseDetailTabId>[] = [
    {
      id: "devices",
      label: t("detail.tabs.devices"),
      icon: <Tablet className="h-4 w-4" />,
    },
    ...(showPresencesTab
      ? [
          {
            id: "presences" as const,
            label: t("detail.tabs.presences"),
            icon: <Users className="h-4 w-4" />,
          },
        ]
      : []),
    {
      id: "general",
      label: t("detail.tabs.settings"),
      icon: <Settings2 className="h-4 w-4" />,
    },
  ];

  return (
    <Tabs
      variant="underline"
      idPrefix="house"
      ariaLabel={t("detail.tabs.ariaLabel")}
      activeTab={activeTab}
      onTabChange={onTabChange}
      tabs={tabs}
      className="mb-6 [&>*]:whitespace-nowrap max-sm:gap-0 max-sm:[&>*]:gap-1.5 max-sm:[&>*]:px-2"
    />
  );
}
